<mat-toolbar class="mat-elevation-z0 density5">
    <img src="assets/images/{{ (darkMode$ | async) ? 'logo-white' : 'logo' }}.png" alt="logo" id="logo" />
</mat-toolbar>
<div>
    <h1>404</h1>
    <h3>Page Not found</h3>
    <a mat-button color="warn" routerLink="/admin/dashboard">Dashboard</a>
    <a mat-button color="warn" (click)="location.historyGo(-1)">Back</a>
</div>
